
import Icon from "../../../assets/duotone/Icon.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function IconIcon({ className, dataTestid = "IconIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Icon data-testid={dataTestid} className={classes} {...rest} />
  );
}
